import React, { useState, useEffect } from 'react';
import { ParentContainer, ManualAddressToggle, ModalContainer } from '../styles';
import { AddressContainer } from './style';
import ManualAddress from './ManualAddressForm';
import AddressSearch from './AddressSearch';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  AddressConfig,
  AddressTypes,
  AppDispatch,
  IErrorModalState,
  IStore,
  RemitterDetails
} from '../../../../../store.type';
import { ModalFactory } from '@Components';
import { FormValuesProps } from '../Interfaces/interface';
import { OnboardingStepperCmsData } from '../utils/Interface';
import {
  areAllValuesEmpty,
  getCMSStepperData,
  getContentCountryCode,
  getConsentCountryCodeForAddress,
  getCountrySpecificInputFields,
  getScreensData,
  ROUTE_KEYS
} from '../utils/Util';
import {
  activateLoader,
  disableLoader
} from '../../../../../redux/actions/ui-trigger/ui-trigger-action';
import {
  getCountryNameByCode,
  replaceParams,
  setMalaysiaAddress
} from '../../../../../utils/library';
import {
  changeOnBoardingScreen,
  setBackNavigatedAddressPage,
  storeUserAddress,
  toggleAddressAvailable
} from '../../../../../redux/actions/onboarding/new-onboarding-action';
import { MANUAL_ADDRESS_FORM } from '../../../../../utils/constants';
import { getFormValues, reduxForm, change } from 'redux-form';
import { getAddressConfig } from '../../../../../redux/actions/individual-user-flow/individual-user-flow-action';
import Header from '../components/Header';
import { REVAMPED_SCREENS } from '../utils/constants';
import { CHEVRON_LEFT_ICON, MAP_PIN_ICON } from '@Images';
import { ErrorModal } from '../errorModal';
import { API_URL } from '@Utils/config';
import { makeApiCall } from '@Redux/actions/common';
import { GET_ADDRESS_CONFIG } from '@Redux/action-contants';
import { selectNewBeneState } from '@Redux/selectors';
import { ADDRESS_ARRAY } from '../../../../bene-additional-info/utils/constants';
import { isEmpty } from 'lodash';
import { setAddressConfigAction } from '@Redux/actions/new-bene-flow/new-bene-flow-action';

type AddressFlowProps = {
  userInfo?: any;
  isAddressPageHaveData: boolean;
  isAddressPageBackNavigated: boolean;
  countryCode: string;
  dispatch?: any;
  getAllformVal: any;
  addressConfig: AddressConfig;
  addressInfo: AddressTypes;
  remitterDetails: RemitterDetails;
  activateLoader: any;
  disableLoader: any;
  errorModalState: IErrorModalState;
  isBeneAddressFlow?: boolean;
  onSubmitBeneFlow?: () => void;
  isEditFlow?: boolean;
  isRFIflow?: boolean;
  onRFIBack?: () => void;
  onRFISave?: (data: any) => void;
  remitterDetailsOverride?: RemitterDetails;
  // ODD RFI reuses this component the same way the bene flow does above — its own
  // isolated branch so its data never touches the onboarding/bene reducers.
  isOddAddressFlow?: boolean;
  onSubmitOddFlow?: (payload: FormValuesProps) => void;
  oddUserInfo?: any;
  oddCountryCode?: string;
  oddAddressConfigUrl?: string;
  onOddAddressConfigLoaded?: (config: AddressConfig) => void;
};

export const INITIAL_STATE_ADDRESS_FORM = {
  unit_number: '',
  street_number: '',
  street_name: '',
  building_name: '',
  building_number: '',
  suburb: '',
  state: '',
  city: '',
  postcode: '',
  is_mailing_address_diff: false,
  residential: {},
  mailing: {},
  address1: '',
  address2: '',
  province: ''
};

const AddressFlowForm = (props: AddressFlowProps): React.ReactElement => {
  const {
    userInfo: userInfoProp,
    countryCode: countryCodeProp,
    getAllformVal,
    isAddressPageHaveData,
    isAddressPageBackNavigated,
    addressConfig: addressConfigProp,
    remitterDetails,
    addressInfo,
    activateLoader,
    disableLoader,
    errorModalState,
    isBeneAddressFlow,
    onSubmitBeneFlow,
    isEditFlow,
    isRFIflow,
    onRFIBack,
    onRFISave,
    remitterDetailsOverride,
    isOddAddressFlow,
    onSubmitOddFlow,
    oddUserInfo,
    oddCountryCode,
    oddAddressConfigUrl,
    onOddAddressConfigLoaded
  } = props;
  // In the RFI edit flow, remitterDetails from userDataReducer isn't populated (that
  // slice is only hydrated by the onboarding wizard) — use the profile data Rfi.js
  // already fetched instead.
  const effectiveRemitterDetails = remitterDetailsOverride || remitterDetails;
  // ODD supplies its own data (fetched via its own url, held in local state below)
  // instead of the onboarding/bene reducers connect() would otherwise inject.
  const userInfo = isOddAddressFlow ? oddUserInfo : userInfoProp;
  const countryCode = (isOddAddressFlow ? oddCountryCode : countryCodeProp) as string;
  const [oddAddressConfig, setOddAddressConfig] = useState<AddressConfig | undefined>();
  const addressConfig = isOddAddressFlow ? oddAddressConfig : addressConfigProp;
  const countryName = getCountryNameByCode(countryCode);
  const dispatch = useDispatch<AppDispatch>();
  const contentCountryCode = getContentCountryCode(countryCode);
  const contentCountryCodeForAddress = getConsentCountryCodeForAddress(countryCode);
  const [cmsData, setCMSData] = useState<OnboardingStepperCmsData | undefined>();
  const [cmsInputFields, setCmsInputFields] = useState<any[]>();
  const [isManualSearch, setIsManualSearch] = useState<boolean>(
    isRFIflow || isOddAddressFlow
      ? true
      : isAddressPageHaveData || isAddressPageBackNavigated || false
  );
  const address = !isBeneAddressFlow
    ? setMalaysiaAddress(effectiveRemitterDetails)
    : { residential: {}, mailing: {} };
  const [retrievedValues, setRetrievedValues] = useState<AddressTypes>(
    isOddAddressFlow
      ? (userInfo as AddressTypes)
      : isAddressPageHaveData && !isAddressPageBackNavigated
      ? addressInfo
      : { ...effectiveRemitterDetails, ...address }
  );

  const screenData = getScreensData(ROUTE_KEYS.AddressInformation, contentCountryCode);
  const stepperData = screenData?.stepperData;
  const constantText = screenData?.constants;

  const {
    formValues,
    isBeneSchemaEnabled,
    schemaApiResponse,
    isSelfBene,
    currentBene,
    currentFormBeneAddress,
    shouldPrefillBeneAddress
  } = useSelector(selectNewBeneState);

  const prefillBeneAddress = (remitterDetails: Record<string, any> = {}) => {
    ADDRESS_ARRAY.forEach((key) => {
      let value = remitterDetails?.[key] ?? '';

      if (key === 'street' && !value) {
        value = remitterDetails?.['street_name'] || '';
      }
      if (!isEmpty(value)) {
        dispatch(change(MANUAL_ADDRESS_FORM, key, value));
      }
    });
  };

  const handleBeneAddressFlow = async () => {
    if (!isBeneSchemaEnabled) {
      const response = await dispatch(
        getAddressConfig({
          country_code: isEditFlow
            ? currentBene?.country_code || currentBene?.beneficiary_country_code
            : formValues?.country_code
        })
      );
      dispatch(setAddressConfigAction(response.data));
      return;
    }

    let addressApiUrl = schemaApiResponse?.address?.api?.url;
    if (!addressApiUrl) return;

    addressApiUrl = replaceParams(addressApiUrl, {
      beneficiary_country_code: formValues?.beneficiary_country_code?.toUpperCase(),
      routing_config_type: isEditFlow
        ? currentBene?.routing_config_type
        : formValues?.routing_config_type_temp?.toUpperCase()
    });

    dispatch({ type: GET_ADDRESS_CONFIG });

    try {
      const { data } = await makeApiCall({
        method: 'get',
        url: `${API_URL}${addressApiUrl}`,
        withCredentials: true
      });

      dispatch({
        type: data.success ? `${GET_ADDRESS_CONFIG}_SUCCESS` : `${GET_ADDRESS_CONFIG}_ERROR`,
        payload: data.success ? data.data : undefined
      });
      dispatch(setAddressConfigAction(data.data.address_details || {}));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Address API call failed:', err);
      dispatch({ type: `${GET_ADDRESS_CONFIG}_ERROR` });
    }
  };

  const fetchOddAddressConfig = async () => {
    if (!oddAddressConfigUrl) return;
    activateLoader();
    try {
      const { data } = await makeApiCall({
        method: 'get',
        url: `${API_URL}${oddAddressConfigUrl}`,
        withCredentials: true
      });
      if (data?.success) {
        setOddAddressConfig(data.data);
        onOddAddressConfigLoaded?.(data.data);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ODD address config fetch failed:', err);
    } finally {
      disableLoader();
    }
  };

  const fetchData = () => {
    if (!countryCode) return;

    if (isOddAddressFlow) {
      fetchOddAddressConfig();
      return;
    }

    activateLoader();

    try {
      if (isBeneAddressFlow) {
        handleBeneAddressFlow();
      } else {
        dispatch(getAddressConfig({ country_code: countryCode }));
      }
    } finally {
      disableLoader();
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  useEffect(() => {
    if (isBeneAddressFlow && (shouldPrefillBeneAddress || !isEmpty(currentFormBeneAddress))) {
      handleRetrievedValuesCallBack(currentFormBeneAddress || {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBeneAddressFlow, shouldPrefillBeneAddress, currentFormBeneAddress]);
  useEffect(() => {
    const fetchData = async () => {
      // ODD supplies its own heading/copy — no CMS content needed for this branch
      if (isOddAddressFlow) return;
      activateLoader();
      await getCMSData();
      handleShowAddress();
      disableLoader();
    };
    if (errorModalState?.showModal) {
      showErrorModal();
    }
    fetchData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isEditFlow) return;
    prefillBeneAddress(currentBene);
    handleAddressToggle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelfBene]);

  const showErrorModal = async () => {
    //@ts-ignore
    await ModalFactory.builder(
      (onClose: any) => <ErrorModal onClose={onClose} errorModalState={errorModalState} />,
      'error-modal',
      true
    );
  };

  const getCMSData = async () => {
    const stepperCmsData = await getCMSStepperData(
      ROUTE_KEYS.AddressInformation,
      contentCountryCode
    );
    setCMSData(stepperCmsData);
    const dynamicInputFields = getCountrySpecificInputFields(
      stepperCmsData?.dynamicInputFields,
      contentCountryCodeForAddress
    );
    setCmsInputFields(dynamicInputFields);
  };

  const handleShowAddress = () => {
    if (userInfo?.person?.addresses?.length) {
      handleRetrievedAddress();
    }
  };

  const handleAddressToggle = () => {
    if (!isManualSearch) {
      setRetrievedValues(INITIAL_STATE_ADDRESS_FORM);
    }
    setIsManualSearch(!isManualSearch);
  };

  const handleSearchCallback = (value: boolean) => {
    setIsManualSearch(value);
    setRetrievedValues(INITIAL_STATE_ADDRESS_FORM);
  };

  const handleConfirmAddress = async (onClose: any) => {
    const parsedAddress = userInfo?.person?.addresses[0].parsedAddress;
    if (parsedAddress) {
      const { street, state, postcode, suburb, streetNumber } = parsedAddress;
      const confirmedAddress = {
        street_name: street?.replace(/[^A-Za-z]/g, ' ').trim() || '',
        suburb: suburb || '',
        postcode: postcode || '',
        state: state || '',
        street_number: streetNumber || street?.replace(/\D/g, '') || ''
      };
      await onClose(true);
      setRetrievedValues({ ...retrievedValues, ...confirmedAddress });
      setIsManualSearch(!isManualSearch);
    }
  };

  const handleRetrievedValuesCallBack = (value: AddressTypes) => {
    const mergedValues = { ...INITIAL_STATE_ADDRESS_FORM, ...value };

    setRetrievedValues(mergedValues);
    setIsManualSearch(true);

    Object.entries(mergedValues).forEach(([key, val]) => {
      dispatch(change(MANUAL_ADDRESS_FORM, key, val ?? ''));
    });
  };

  const handleRetrievedAddress = async () => {
    //@ts-ignore
    return await ModalFactory.builder(
      //@ts-ignore
      (onClose) => (
        <ModalContainer
          containerMarginTop={32}
          buttonTopMargin={16}
          buttonWidth={418}
          height={362}
          width={450}
        >
          <div className="modal-body-container">
            <div className="header-container">
              <span className="__address-heading">Your address in Australia</span>
              <span className="__address-heading-desc">
                Is the below address from your driver&apos;s license your current address?
              </span>
            </div>
            <span className="full-address-container">
              {userInfo?.person?.addresses[0].fullAddress}
            </span>
            <button onClick={() => handleConfirmAddress(onClose)} className="submit-button">
              This is my address
            </button>
            <span onClick={() => onClose(true)} className="different-address-container">
              My address is different
            </span>
          </div>
        </ModalContainer>
      ),
      'send-money-bene-modal insta-modal center-modal',
      true
    );
  };

  const replaceCountryName = (stringValue: string) => {
    if (['CZ', 'NL', 'GB'].includes(countryCode))
      return stringValue.replace(/{COUNTRY}/gi, 'the ' + countryName);
    return stringValue.replace(/{COUNTRY}/gi, countryName);
  };

  const handleNavigateBack = () => {
    if (isManualSearch) {
      /*
        isManualSearch true means we are on address page and need to go back to address search page,
        if address fields have data, store it in addressInfo slice of reducer, if it dont have, store
        empty object and set isAddressPageHaveData to false.
      */
      const isFormEmpty = areAllValuesEmpty(getAllformVal, contentCountryCodeForAddress);
      getAllformVal && !isFormEmpty && dispatch(storeUserAddress(getAllformVal));
      if (getAllformVal && isFormEmpty) {
        dispatch(toggleAddressAvailable(false));
        dispatch(storeUserAddress({}));
      }
      setIsManualSearch(false);
      dispatch(setBackNavigatedAddressPage(false));
    } else {
      /* User is on Address Search Page */
      const previousScreen =
        contentCountryCode === 'EU'
          ? REVAMPED_SCREENS.taxInformation
          : REVAMPED_SCREENS.personalInformation;
      dispatch(changeOnBoardingScreen(previousScreen));
    }
  };

  if (isBeneAddressFlow) {
    return (
      <div className="child-component-container__content-container">
        <AddressContainer>
          {isManualSearch ? (
            <>
              <ManualAddress
                //@ts-ignore
                addressSearchHandler={handleSearchCallback}
                retrievedValues={retrievedValues}
                cmsData={cmsData}
                cmsInputFields={cmsInputFields}
                constantText={constantText}
                countryCode={countryCode}
                addressConfig={addressConfig}
                contentCountryCode={contentCountryCodeForAddress}
                isBeneAddressFlow={isBeneAddressFlow}
                isBeneSchemaEnabled={isBeneSchemaEnabled}
                onSubmitBeneFlow={onSubmitBeneFlow}
                handleAddressToggle={handleAddressToggle}
              />
            </>
          ) : (
            // @ts-ignore
            <AddressSearch
              retrievedValuesCallBack={handleRetrievedValuesCallBack}
              searchPlaceHolder="Start typing address here"
              isBeneAddressFlow={isBeneAddressFlow}
            />
          )}
          {!isManualSearch && (
            <ManualAddressToggle onClick={handleAddressToggle}>
              <span>Enter Address Manually</span>
            </ManualAddressToggle>
          )}
        </AddressContainer>
      </div>
    );
  }

  return (
    <ParentContainer padding={[-2, 0]}>
      {(!isRFIflow || !isOddAddressFlow) &&
        (countryCode === 'MY' || contentCountryCode === 'EU' || contentCountryCode === 'GB') && (
          <div className="navigation-container">
            <img
              onClick={handleNavigateBack}
              className="back-button"
              src={CHEVRON_LEFT_ICON}
              alt="back"
            />
          </div>
        )}
      {isRFIflow ? (
        <div className="header-text-container">
          <h1 className="heading-text">{replaceCountryName(cmsData?.heading ?? '')}</h1>
          <span className="heading-description" style={{ textAlign: 'left' }}>
            {replaceCountryName(cmsData?.description ?? '')}
          </span>
        </div>
      ) : (
        !isOddAddressFlow && (
          <Header
            heading={replaceCountryName(cmsData?.heading ?? '')}
            headerLogo={MAP_PIN_ICON}
            stepNumber={stepperData?.stepNumber}
            totalSteps={stepperData?.totalSteps}
            subHeading={replaceCountryName(cmsData?.description ?? '')}
          />
        )
      )}
      {isManualSearch ? (
        <ManualAddress
          //@ts-ignore
          addressSearchHandler={handleSearchCallback}
          retrievedValues={retrievedValues}
          cmsData={cmsData}
          cmsInputFields={cmsInputFields}
          constantText={constantText}
          countryCode={countryCode}
          addressConfig={addressConfig}
          contentCountryCode={contentCountryCodeForAddress}
          isRFIflow={isRFIflow}
          onRFIBack={onRFIBack}
          onRFISave={onRFISave}
          isOddAddressFlow={isOddAddressFlow}
          onSubmitOddFlow={onSubmitOddFlow}
        />
      ) : (
        // @ts-ignore
        <AddressSearch
          retrievedValuesCallBack={handleRetrievedValuesCallBack}
          searchPlaceHolder={constantText?.searchPlaceHolder}
          onEnterManually={handleAddressToggle}
          {...(isOddAddressFlow ? { countryCode } : {})}
        />
      )}
      {!isManualSearch && !isRFIflow && (
        <ManualAddressToggle onClick={handleAddressToggle}>
          <span>{constantText?.toggleAddressText}</span>
        </ManualAddressToggle>
      )}
    </ParentContainer>
  );
};

const AddressFlow = reduxForm<null, any>({
  form: MANUAL_ADDRESS_FORM
})(AddressFlowForm);

function mapStateToProps(reduxState: IStore) {
  const {
    rootReducer: {
      newUserFlowReducer: {
        userInfo,
        isAddressPageHaveData,
        isAddressPageBackNavigated,
        addressInfo,
        errorModalState
      },
      userStatusReducer: { country_code: countryCode },
      userDataReducer: {
        addressConfig: { data },
        userStateInfo: { remitterDetails }
      }
    }
  } = reduxState;
  const getAllformVal = getFormValues(MANUAL_ADDRESS_FORM)(reduxState);

  return {
    userInfo,
    isAddressPageHaveData,
    isAddressPageBackNavigated,
    countryCode,
    getAllformVal,
    addressInfo,
    addressConfig: data || {},
    remitterDetails,
    errorModalState
  };
}

export default connect<any, any, any, IStore>(mapStateToProps, {
  activateLoader,
  disableLoader
})(AddressFlow);
